import styles from './NewOverdueView.module.css';
import { AlertBox, Icon } from '@iwoca/orion';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

export const OverdueAlert = ({ overdueAmount }: { overdueAmount: number }) => {
    return (
        <AlertBox variant="failure" className={styles.alertBox}>
            <Icon icon="alertCircle" className={styles.icon} />
            <div className={styles.descriptionContainer}>
                <p className={styles.description}>
                    <strong>Time to get back on track</strong> - you're overdue
                    by{' '}
                    <strong>
                        {<FormattedCurrency value={overdueAmount} />}
                    </strong>
                </p>
            </div>
        </AlertBox>
    );
};
